import { Card, CardContent, Typography, Box, Tooltip } from '@mui/material';
import React from 'react';

const Cards = ({ title, content, contentSpacing = "20px", contentMarginTop  }) => {
  return (
    <Card sx={{ width: "40%",  borderRadius: "10px" }}>
      <CardContent>
        <Box sx={{height: "6rem", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>

          {/* Check if content is an array */}
         <Typography
                  sx={{
                    fontSize: "14px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%", // To ensure the text takes full width and cuts off when too long
                  }}
                >
                  {content}
                </Typography>
            </Box>
      </CardContent>
    </Card>
  );
};

export default Cards;